import Vue from 'vue'
import FieldModifications from './FieldModifications'
import store from '@/store'
import config from '@/mixins/componentConfiguration'
import commonConfig from '@/mixins/commonMixin'

window.vm = new Vue({
  store,
  mixins: [commonConfig(Vue), config(Vue)],
  render: h => h(FieldModifications)
}).$mount('#fieldmods')
